/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BlobFolderContent } from '../models/BlobFolderContent';
import type { BlobStorageContentResponse } from '../models/BlobStorageContentResponse';
import type { TenantBlobFolder } from '../models/TenantBlobFolder';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BlobService {

    /**
     * Gets all folders and files in the tenant's blob storage
     * @returns BlobStorageContentResponse OK
     * @throws ApiError
     */
    public static getBlobStorageContent(): CancelablePromise<BlobStorageContentResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/Blob/Content',
        });
    }

    /**
     * Gets files in a specific folder of the tenant's blob storage
     * @param folder 
     * @returns BlobFolderContent OK
     * @throws ApiError
     */
    public static getBlobFolderContent(
folder: TenantBlobFolder,
): CancelablePromise<BlobFolderContent> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/Blob/Folders/{folder}',
            path: {
                'folder': folder,
            },
        });
    }

    /**
     * Returns a short-lived SAS URL to download a file directly from Azure Blob Storage
     * @param folder 
     * @param filePath 
     * @returns string OK
     * @throws ApiError
     */
    public static downloadBlobFile(
folder: TenantBlobFolder,
filePath: string,
): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/Blob/Download/{folder}/{filePath}',
            path: {
                'folder': folder,
                'filePath': filePath,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * Deletes a file from the tenant's blob storage
     * @param folder 
     * @param filePath 
     * @returns any OK
     * @throws ApiError
     */
    public static deleteBlobFile(
folder: TenantBlobFolder,
filePath: string,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/Blob/Files/{folder}/{filePath}',
            path: {
                'folder': folder,
                'filePath': filePath,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }

}
